<div class="personal_information_container">
    <div class="personal_information_title">{{"personal_information.title" | translate}}</div>
    <div class="input_and_error">
        <form [formGroup]="userEmailForm">
            <mat-form-field appearance="outline">
                <mat-label>{{ "personal_information.email" | translate}}</mat-label>
                <input matInput placeholder="Votre email" [maxLength]="maxLength"
                    matTooltip="{{'character_limit'| translate}}" required="true" type="email" #userEmail
                    (keyup)="emailValidCheck(userEmail.value)" formControlName="email"
                    [errorStateMatcher]="confirmValidParentMatcher">
                    <mat-icon *ngIf="!isEmailInputValid" matSuffix [ngStyle]="{'color': 'red'}">error</mat-icon>
                <mat-error>
                    {{"personal_information.error_email" | translate}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>

    <div class="personal_information_email_subtitle">{{"personal_information.email_subtitle" | translate}}</div>
    <br />
</div>